// filepath: apps/web/src/features/directory/people-directory/PeopleDirectoryRow.tsx
//
// FR-UI-DIR-1 AC-1 — single row in the people directory table.
//
// INV-2: every field rendered here originates from the Person server
// shape -- never synthesise a name or PII substitute on the client.
// Tokens via var(--semantic-alias) only.

import React from "react";
import { navigate } from "@/features/cabinet/usePathname";
import { useTranslation } from "@/i18n/useTranslation";
import type { Person } from "../types";

export interface PeopleDirectoryRowProps {
  person: Person;
}

export function PeopleDirectoryRow({
  person,
}: PeopleDirectoryRowProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <tr
      className="directory-people__row"
      data-testid={`people-row-${person.id}`}
    >
      <td className="directory-people__cell directory-people__cell--name">
        <a
          href={`/people/${person.id}`}
          className="directory-people__name"
          onClick={(e) => {
            if (
              e.defaultPrevented ||
              e.button !== 0 ||
              e.metaKey ||
              e.altKey ||
              e.ctrlKey ||
              e.shiftKey
            ) {
              return;
            }
            e.preventDefault();
            navigate(`/people/${person.id}`);
          }}
        >
          {person.display_name}
        </a>
      </td>
      <td className="directory-people__cell directory-people__cell--title">
        {person.display_name ?? t("directory.people.cell.name.empty", "—")}
      </td>
      <td className="directory-people__cell directory-people__cell--unit">
        "—"
      </td>
      <td className="directory-people__cell directory-people__cell--status">
        <span
          className={`directory-people__status directory-people__status--${person.status}`}
          data-status={person.status}
        >
          {t(`directory.people.status.${person.status}`)}
        </span>
      </td>
    </tr>
  );
}
